"use strict";

exports.__esModule = true;
exports.ErrorAlert = ErrorAlert;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _reactIntl = require("react-intl");
var _Heading = require("../Heading");
var _Text = require("../Text");
var _excluded = ["error", "title", "description"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * Shows details about an error in an Alert.
 */
function ErrorAlert(_ref) {
  var error = _ref.error,
    title = _ref.title,
    description = _ref.description,
    extra = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_core.Alert, _extends({
    intent: _core.Intent.DANGER,
    icon: _icons.IconNames.WARNING_SIGN
  }, extra), /*#__PURE__*/_react["default"].createElement(_Heading.Heading, {
    level: 4
  }, title || /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "ErrorAlert.title",
    defaultMessage: "Something went wrong"
  })), /*#__PURE__*/_react["default"].createElement(_Text.Text, {
    block: true
  }, description || /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "ErrorAlert.description",
    defaultMessage: "The problem has been automatically reported."
  })), /*#__PURE__*/_react["default"].createElement(_Text.Text, {
    block: true,
    muted: true
  }, /*#__PURE__*/_react["default"].createElement("strong", null, error.name), " ", /*#__PURE__*/_react["default"].createElement("em", null, error.message)));
}